import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { colors } from "../../../../../theme/colors";
import { Typography } from "@mui/material";

const steps = ["Pedido criado", "Em separação", "Enviado"];

export default function StepperAcordion({
  status,
  returningTrackingCode,
}: {
  status: string;
  returningTrackingCode?: string;
}) {
  const stepsNumber = {
    ordered: 1,
    separeted: 2,
    send: 3,
  };

  const statusExists = ["ordered", "separeted", "send"];
  return (
    <Box sx={{ width: "100%", mt: 3 }}>
      {statusExists.includes(status) && (
        <Stepper activeStep={stepsNumber[status]} alternativeLabel>
          {steps.map((label) => (
            <Step
              key={label}
              sx={{
                "& .MuiStepLabel-root .Mui-active": {
                  color: colors.purple[500],
                },
                "& .MuiStepLabel-root .Mui-completed": {
                  color: colors.green[400],
                },
              }}
            >
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      )}
      {[
        "partialWithRefund",
        "totalWithRefund",
        "totalWithoutRefund",
        "totalWithRefund",
      ].includes(status) && (
        <Typography
          fontSize={16}
          fontWeight={700}
          color={colors.purple[500]}
          textAlign={"center"}
        >
          Este pedido foi cancelado
        </Typography>
      )}
      {status === "returnToStock" && returningTrackingCode && (
        <>
          <Typography
            fontSize={16}
            fontWeight={700}
            color={colors.purple[500]}
            textAlign={"center"}
          >
            Solicitado devolução do pedido, o seu codigo de rastreio para
            devolução é:
          </Typography>
          <Typography
            fontSize={22}
            fontWeight={700}
            color={colors.purple[700]}
            textAlign={"center"}
          >
            {returningTrackingCode}
          </Typography>
        </>
      )}
      {status === "returnToStock" && !returningTrackingCode && (
        <Typography>
          Aguarde, logo será enviado o código de rastreio da devolução
        </Typography>
      )}
    </Box>
  );
}
